// extracted by mini-css-extract-plugin
export default {"container":"BusinessSchedule_container__QHb4e","leftHolder":"BusinessSchedule_leftHolder__-o26X","rightHolder":"BusinessSchedule_rightHolder__Q8dXt"};